import http from "./http-common";

/**
 * It's a function that returns an object with two functions.
 * @returns An object with multiple functions.
 */
export const StripeService = () => {
 
    const StripeCheckoutSession = (stripeRequest) => http.post(`/stripe/create-checkout-session` , stripeRequest);  

    const StripeCancelSubscription = (stripeRequest) => http.post(`/stripe/cancel-subscription` , stripeRequest);     
    
    return { 
        StripeCheckoutSession,
        StripeCancelSubscription
    };
};